import moment from 'moment-timezone'

export default {
  getNextAvailableTime () {
    moment.tz.setDefault('Asia/Bangkok')
    const currentHour = moment().hour()
    const currentMinute = moment().minute()

    let additionalHours = 3
    let nextMinute
    if (currentMinute > 0 && currentMinute < 15) {
      nextMinute = '00'
    } else if (currentMinute > 15 && currentMinute < 45) {
      nextMinute = '30'
    } else {
      nextMinute = '00'
      additionalHours = 4
    }

    const nextHour = currentHour + additionalHours
    return (nextHour >= 7 && nextHour <= 19) ? ('0' + nextHour).slice(-2) + ':' + nextMinute : null
  },
  getNextAvailableFullTime () {
    moment.tz.setDefault('Asia/Bangkok')
    const currentHour = moment().hour()
    const currentMinute = moment().minute()

    let additionalHours = 3
    let nextMinute
    if (currentMinute < 30) {
      nextMinute = '00'
    } else {
      nextMinute = '00'
      additionalHours = 4
    }

    const nextHour = currentHour + additionalHours
    return (nextHour >= 7 && nextHour <= 19) ? ('0' + nextHour).slice(-2) + ':' + nextMinute : null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/timeHelpers.js